<template>
  <section>
    <div class="container">
      <h2 class="h1 font-gradient text-center mb-4 mb-lg-5">{{ title }}</h2>
    </div>
    <section class="position-relative pt-0">
      <div class="bg-element text-element">
        &lt;{{ bgTitle1 }}/&gt;
      </div>
      <div class="container items-highlighted">
        <SkillsetListComponent :list="skillsetFe" />
      </div>
    </section>
    <section class="position-relative pt-0">
      <div class="bg-element text-element">
        &lt;{{ bgTitle2 }}/&gt;
      </div>
      <div class="container items-highlighted">
        <SkillsetListComponent :list="skillsetBe" />
      </div>
    </section>
    <section class="py-0">
      <div class="row">
        <div class="col-lg-4 mt-4 mt-lg-5 text-white text-center mx-lg-auto">
          <h3 class="h3 mb-3 mb-lg-4">and some more...</h3>
          <a class="btn btn-primary" :href="linkedin" target="_blank">
              You can check out on Linkedin <i class="lab la-linkedin"></i>
          </a>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import SkillsetListComponent from '@/components/skillset/SkillsetListComponent'

export default {
  name: 'SkillsComponent',
  components: {
    SkillsetListComponent,
  },
  data () {
    return {
      title: 'Dev Skillset',
      bgTitle1: 'Frontend',
      bgTitle2: 'Backend',
      skillsetFe: [
        { name: 'Bootstrap5<br/><span>HTML</span>', img: '' },
        { name: 'SCSS<br/><span>CSS</span>', img: '' },
        { name: 'JQuery<br/><span>Javascript</span>', img: '' },
      ],
      skillsetBe: [
        { name: 'NodeJS<br/><span>Javascript</span>', img: '' },
        { name: 'OctoberCMS<br/><span>PHP</span>', img: '' },
        { name: 'Laravel<br/><span>PHP</span>', img: '' },
      ],
      linkedin: 'https://www.linkedin.com/in/martin-matovski-21b965150/',
    }
  },
  methods: {
  }
}
</script>